export const NAME = 'table-settings';
